/**
 * @generated SignedSource<<3429b33b4ad08b7ddd308d9d1bb37d85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "crmId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Timestamp",
  "kind": "LinkedField",
  "name": "lastModified",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "by",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "crmId",
        "variableName": "crmId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceAddress",
    "kind": "LinkedField",
    "name": "updateServiceAddress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "crmId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Permission",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "permissionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readonly",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailService",
        "kind": "LinkedField",
        "name": "emailServices",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailServiceId",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceAddressesPermissionsTableUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceAddressesPermissionsTableUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "970f2aa839b7cf6376fc9314acead03c",
    "id": null,
    "metadata": {},
    "name": "ServiceAddressesPermissionsTableUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceAddressesPermissionsTableUpdateMutation(\n  $crmId: String!\n  $input: UpdateServiceAddressInput!\n) {\n  updateServiceAddress(crmId: $crmId, input: $input) {\n    crmId\n    permissions {\n      permissionId\n      name\n      isEnabled\n      lastModified {\n        at\n        by\n      }\n      readonly\n    }\n    emailServices {\n      emailServiceId\n      isEnabled\n    }\n    lastModified {\n      at\n      by\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e7e20539c07e1829dc7df40f032f1bfe";

module.exports = node;
